export default "__VITE_ASSET__NZhEW5Fb__"